var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list-view-widget p-15" },
    [
      _c("new-map-view", {
        attrs: { roleId: _vm.roleId, permissions: _vm.permissions },
        on: {
          setMapData: _vm.setMapData,
          viewRegistration: _vm.viewRegistration,
          exportDocumentId: _vm.exportPopup,
        },
      }),
      _vm.dashboardRecordsFlag
        ? _c("registration-details-popup", {
            attrs: {
              dashboardRecordsFlag: _vm.dashboardRecordsFlag,
              permissions: _vm.permissions,
              dataRow: _vm.activeRegistration,
              reportFlag: true,
            },
            on: {
              hidePopup: _vm.hidePopup,
              dashboardWidgets: _vm.dashboardWidgets,
            },
          })
        : _vm._e(),
      _c("permission-access-modal"),
      _c("export-popup", {
        attrs: { documentId: _vm.documentId, mapData: _vm.mapData },
        on: { resetExportPopup: _vm.resetExportPopup },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }